import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import LogReport from 'views/machine/reports/log/log'; // Importing LogReport component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the CasinoReportView.
 * @extends JetView
 */
export default class CasinoReportView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const left = {
            height: screen.width < 500 ? 500 : 0, // Conditional height based on screen width
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label', // Label component for the toolbar
                            label: _('Reporte de Logs'), // Translated label text
                            width: 300, // Fixed width for the label
                        },
                    ],
                },
                LogReport, // Including the LogReport component
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            rows: [
                {
                    responsive: 'a5', // Responsive behavior based on the identifier
                    type: 'wide', // Wide type for the column
                    cols: [left], // Columns containing the left layout
                },
            ],
        };
    }
}

// FILE DOCUMENTED
